import axios from 'axios';
import { adminApi } from '@/lib/adminApi';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const assetUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export const formatPrice = (cents, isFree) =>
  isFree ? 'Free' : `$${(Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '')}`;

export const formatBytes = (n) => {
  if (!n) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(n) / Math.log(1024)), u.length - 1);
  return `${(n / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
};

export const errMsg = (e, fallback = 'Something went wrong. Please try again.') =>
  e?.response?.data?.detail && typeof e.response.data.detail === 'string' ? e.response.data.detail : fallback;

export const digitalApi = {
  list: (params = {}) => axios.get(`${API}/digital-products`, { params }).then((r) => r.data),
  get: (slug, section) => axios.get(`${API}/digital-products/${slug}`, { params: section ? { section } : {} }).then((r) => r.data),
  claim: (slug, body) => axios.post(`${API}/digital-products/${slug}/claim`, body).then((r) => r.data),
  checkout: (slug, body) => axios.post(`${API}/digital-products/${slug}/checkout`, body).then((r) => r.data),
  orderStatus: (sessionId) => axios.get(`${API}/digital-products/order-status`, { params: { session_id: sessionId } }).then((r) => r.data),
  linkInfo: (code) => axios.get(`${API}/digital-downloads/${code}/info`).then((r) => r.data),
  fileUrl: (code) => `${API}/digital-downloads/${code}/file`,
  requestNewLink: (body) => axios.post(`${API}/digital-downloads/request-new-link`, body).then((r) => r.data),
};

export async function uploadAsset(productId, kind, file, onProgress) {
  const init = await adminApi.post(`/admin/digital-products/${productId}/uploads`, {
    kind, filename: file.name, content_type: file.type || null, size: file.size,
  });
  const { upload_id: uid, chunk_size: chunk } = init.data;
  const total = Math.ceil(file.size / chunk);
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * chunk, Math.min(file.size, (i + 1) * chunk));
    await adminApi.put(`/admin/digital-products/uploads/${uid}/chunk`, blob, {
      params: { index: i }, headers: { 'Content-Type': 'application/octet-stream' },
    });
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const done = await adminApi.post(`/admin/digital-products/uploads/${uid}/complete`);
  onProgress?.(100);
  return done.data;
}
